
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.288","height":"12.416","viewBox":"0 0 15.288 12.416"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 155246","d":"M13.716 3.095a6.735 6.735 0 001.571-1.62 6.282 6.282 0 01-1.8.485A3.125 3.125 0 0014.864.233a6.168 6.168 0 01-1.989.757 3.126 3.126 0 00-2.289-.989A3.132 3.132 0 007.45 3.133a3.537 3.537 0 00.078.718A8.906 8.906 0 011.068.572a3.109 3.109 0 00-.427 1.581 3.131 3.131 0 001.4 2.609 3.155 3.155 0 01-1.416-.4v.039a3.134 3.134 0 002.508 3.078 3.313 3.313 0 01-.825.107 3.949 3.949 0 01-.592-.048 3.139 3.139 0 002.93 2.173 6.275 6.275 0 01-3.89 1.339A6.484 6.484 0 010 11.01a8.854 8.854 0 004.811 1.406 8.853 8.853 0 008.915-8.914c0-.136 0-.272-.01-.407z","fill":"#fff"}})])
          )
        }
      }
    